import { GET_CMS_CONTENT, GET_QUESTION_ANSWER, LOGOUT } from "../actions/types";

const initialState = {
  cms: null,
  loading: true,
  questionAnswer: [],
};

const cmsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_CMS_CONTENT:
      return {
        ...state,
        cms: payload,
        loading: false,
      };
    case GET_QUESTION_ANSWER:
      return {
        ...state,
        questionAnswer: payload,
        loading: false,
      };
    case LOGOUT:
      return {
        questionAnswer: [],
      };
    default:
      return state;
  }
};

export default cmsReducer;
